import { useCallback } from "react";
import { useAuthenticated } from "../auth";
import { locationSubmissionInterval } from "../config";
import { usePortalApi } from "../db/portal-api";
import { useActiveMission } from "../missions";
import { useInterval } from "../utils";
import { useCurrentLocation } from "./location";

export default function LocationSubmitter() {
  const { positionSenden } = useAuthenticated();
  return positionSenden ? <ActiveLocationSubmitter /> : null;
}

function ActiveLocationSubmitter() {
  const { portalKey } = useAuthenticated();
  const { useNewApi, baseUrl } = usePortalApi();
  const activeMission = useActiveMission();
  const { location, accuracy } = useCurrentLocation();

  const submitLocation = useCallback(async () => {
    // The legacy portal has no equivalent endpoint — simply don't submit for it.
    if (!useNewApi || !baseUrl) return;
    if (!activeMission || !location || !accuracy) return;

    try {
      const response = await fetch(`${baseUrl}/api/device/location`, {
        method: "POST",
        headers: {
          accept: "application/json",
          "content-type": "application/json",
          authorization: `Bearer ${portalKey}`,
        },
        body: JSON.stringify({
          lat: location.latitude,
          lng: location.longitude,
          accuracy,
        }),
      });
      if (!response.ok)
        throw new Error(`Fehler: ${response.status} ${response.statusText}`);
    } catch (error) {
      console.error("Error reporting location:", error);
    }
  }, [useNewApi, baseUrl, portalKey, activeMission, location, accuracy]);

  useInterval(submitLocation, locationSubmissionInterval);

  return null;
}
